import React from 'react'
import useIsMobile from '../hooks/useIsMobile';

const AppPaginator = (props) => {
    const { entityName, currentPage,totalPages, setCurrentPage } = props;
    const isMobile = useIsMobile();
    const pageRange = (isMobile?1:5);
    // 1. Determine the first page number to display
const startPage = Math.max(1, currentPage - pageRange);

// 2. Determine the last page number to display
const endPage = Math.min(totalPages, currentPage + pageRange);

// 3. Create the array based on the start and end pages
const pageNumbers = Array.from({ length: (endPage - startPage) + 1 }, (_, index) => startPage + index);
    return (
        <>
            <div className="d-flex mb-2 mb-md-auto pagination-container">

             

                <ul className="pagination app-pagination">
                    <li className={`page-item ${currentPage == 1?'disabled':''}`}>
                        <a onClick={() => setCurrentPage(currentPage - 1)} className="page-link b-r-left">Previous</a>
                    </li>
                    {pageNumbers.map((number) => (
                             <li key={number} className={`page-item ${currentPage == number ? 'active' : ''}`} ><a onClick={() => setCurrentPage(number)} className="page-link" > {number}</a></li>
                        ))}
                   
                    
                    <li className={`page-item ${currentPage == pageNumbers.length ?'disabled':''}`}>
                        <a onClick={() => setCurrentPage(currentPage + 1)} className="page-link" href="#">Next</a>
                    </li>
                </ul>
                    <div className="d-none d-md-block text-end m-2">
                        Total Pages: {totalPages}
                    </div>
            </div>
        </>
    )
}

export default AppPaginator
